import { useCurrentAlbumId } from "./state";
import { atom, useAtom } from "jotai";
import { useState, useEffect } from "react";
import { IndexedTunes, getAlbumKanjiHint } from "./search";
import { run } from "./util/lazy";
import { DAO } from "./dao/dao";

export const albumTuneListAtom = atom<IndexedTunes>(IndexedTunes.Nullish());

export function useTuneList() {
  const currentAlbumId = useCurrentAlbumId();
  const [tunes, setTunes] = useAtom(albumTuneListAtom);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!currentAlbumId) {
      setTunes(IndexedTunes.Nullish());
      return;
    }
    run(async () => {
      setLoading(true);
      const kanjiHint = getAlbumKanjiHint(currentAlbumId);
      const tunes = DAO.lookupTunesInAlbum(currentAlbumId);
      const indexed = (await kanjiHint).indexTunes(await tunes);
      setLoading(false);
      setTunes(indexed);
    });
  }, [currentAlbumId]);
  return { loading, tunes, indices: tunes.indices };
}
